import { BaseDto } from "@models/base/baseDto.model";

export class InquilinoDto extends BaseDto{
    public persona!:BaseDto
}
